module.exports = __webpack_public_path__ + "img/cover18.1a7af349.png";